import React from 'react';
import styles from '../styles/Home.module.css'
import { useWhichDashboard } from '../hooks/useWhichDashboard';

export default function Home() {
  const dashData = useWhichDashboard();

  React.useEffect(() => {
    // <Head> o‘rniga document orqali <link> qo‘shish
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.sizes = '32x32';
    link.href = '/logo.png';
    document.head.appendChild(link);

    // tozalash
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <h1 className={styles.title}>
          Welcome to <a href={dashData.dashboard}>{dashData.title} Trackings</a>
        </h1>
      </main>
    </div>
  );
}
